module.exports = __webpack_public_path__ + "static/media/NextButtonImg.56d91cd0.svg";